import { useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { drumLanguageAtom, drumUserPreferencesAtom, drumUserTokenAtom, type DrumUserPreferences } from '../../shared/store/drumAppAtoms';
import { saveMemberPreferences } from '../../shared/api/memberApi';
import './Notifications.scss';

const ROWS: Array<[Extract<keyof DrumUserPreferences, 'notifyNewSongs' | 'notifyNotices' | 'notifyCognitive'>, string, string]> = [
  ['notifyNewSongs', 'New songs', 'Get notified when new playable songs are released.'],
  ['notifyNotices', 'Notice updates', 'Get notified when a new service notice is published.'],
  ['notifyCognitive', 'New cognitive activities', 'Get notified when a new cognitive activity is available.'],
];

function Notifications() {
  const token = useAtomValue(drumUserTokenAtom);
  const language = useAtomValue(drumLanguageAtom);
  const [preferences, setPreferences] = useAtom(drumUserPreferencesAtom);
  const [errorMessage, setErrorMessage] = useState('');

  const togglePreference = async (id: typeof ROWS[number][0]) => {
    const previous = preferences;
    const next = { ...preferences, [id]: !preferences[id] };
    setPreferences(next);
    setErrorMessage('');
    if (!token) return;
    try {
      const saved = await saveMemberPreferences(token, { [id]: next[id] });
      setPreferences(saved);
    } catch (error) {
      setPreferences(previous);
      setErrorMessage(error instanceof Error ? error.message : (language === 'ko' ? '설정을 저장하지 못했습니다.' : 'Unable to save changes.'));
    }
  };

  return (
    <div className="page profile-subpage">
      <div className="page-intro"><span className="eyebrow">ACCOUNT</span><h1>Notifications</h1><p>Choose which DRUM Hi updates appear on this tablet.</p></div>
      <section className="preference-list">
        {ROWS.map(([id, title, copy]) => (
          <button type="button" role="switch" aria-checked={preferences[id]} className="preference-row" key={id} onClick={() => togglePreference(id)}>
            <span><strong>{title}</strong><small>{copy}</small></span>
            <i className={preferences[id] ? 'on' : ''} aria-hidden="true"><b /></i>
          </button>
        ))}
      </section>
      {errorMessage ? <p className="profile-form-status">{errorMessage}</p> : null}
    </div>
  );
}

export default Notifications;
